import React from 'react';
import { Scale, Phone, Mail } from 'lucide-react';
import { studioInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-slate-950 border-t border-slate-800">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Logo & Description */}
          <div className="lg:col-span-2">
            <div className="flex items-center mb-4 bg-white rounded inline-block px-3 py-2">
              <img 
                src="/logo.png" 
                alt="FP Estudio Jurídico" 
                className="h-14 w-auto object-contain"
              />
            </div>
            <p className="text-gray-400 mb-4 max-w-md leading-relaxed">
              Estudio jurídico especializado en derecho penal, sucesiones y aduanero. 
              Comprometidos con la defensa de sus derechos.
            </p>
            <div className="flex items-center space-x-2">
              <Scale className="text-yellow-400" size={20} />
              <span className="text-gray-400 text-sm">Profesionalismo y Experiencia</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('inicio')}
                  className="text-gray-400 hover:text-blue-400 transition-colors"
                >
                  Inicio
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('areas')}
                  className="text-gray-400 hover:text-blue-400 transition-colors"
                >
                  Áreas de Práctica
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('nosotros')}
                  className="text-gray-400 hover:text-blue-400 transition-colors"
                >
                  Sobre Nosotros
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('faq')}
                  className="text-gray-400 hover:text-blue-400 transition-colors"
                >
                  Preguntas Frecuentes
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contacto')}
                  className="text-gray-400 hover:text-blue-400 transition-colors"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold mb-4">Contacto</h4>
            <ul className="space-y-3">
              <li>
                <a 
                  href="tel:2236661214"
                  className="flex items-center space-x-2 text-gray-400 hover:text-blue-400 transition-colors"
                >
                  <Phone size={16} />
                  <div>
                    <span>223 6661214</span>
                    <span className="text-xs ml-1">(Mar del Plata)</span>
                  </div>
                </a>
              </li>
              <li>
                <a 
                  href="tel:2257632222"
                  className="flex items-center space-x-2 text-gray-400 hover:text-blue-400 transition-colors"
                >
                  <Phone size={16} />
                  <div>
                    <span>2257 632222</span>
                    <span className="text-xs ml-1">(Costa Atlántica)</span>
                  </div>
                </a>
              </li>
              <li>
                <a 
                  href={`mailto:${studioInfo.email}`}
                  className="flex items-center space-x-2 text-gray-400 hover:text-blue-400 transition-colors"
                >
                  <Mail size={16} />
                  <span>{studioInfo.email}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} FP Estudio Jurídico. Todos los derechos reservados.
            </p>
            <p className="text-gray-500 text-sm">
              Especialistas en Derecho Penal, Sucesiones y Aduanero
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
